import React from 'react';
import { Heading } from '@kl/components-v6';
import { HeadingProps } from '@kl/components-v6/src/typography/heading/types';
import { Locale, LocaleProps } from 'shared/ui/locale';

export interface LocaleHeadingProps extends HeadingProps, Pick<LocaleProps, 'params'> {
    localizationKey: string;
}

export const LocalizedHeading: React.FC<LocaleHeadingProps> = ({
    params = [],
    localizationKey,
    ...headingProps
}) => (
    <Heading {...headingProps}>
        <Locale localizationKey={localizationKey} params={params} />
    </Heading>
);
